import React from 'react';
import { Plus, Eye, Edit, Trash2 } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { Link } from 'react-router-dom';
export function CreditTypes() {
  const types = [{
    id: 1,
    name: 'General'
  }, {
    id: 2,
    name: 'Legal'
  }, {
    id: 3,
    name: 'Ethics'
  }];
  return <div className="space-y-6 max-w-4xl mx-auto" data-id="element-121">
      <div className="flex items-center justify-between" data-id="element-122">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-123">Credit Types</h1>
        <Link to="/credit-types/add" data-id="element-124">
          <Button className="gap-2" data-id="element-125">
            <Plus className="h-4 w-4" data-id="element-126" />
            Add
          </Button>
        </Link>
      </div>

      <Card className="overflow-hidden" data-id="element-127">
        <div className="overflow-x-auto" data-id="element-128">
          <table className="w-full text-sm text-left" data-id="element-129">
            <thead className="bg-slate-50 text-slate-500 font-medium border-b border-slate-200" data-id="element-130">
              <tr data-id="element-131">
                <th className="px-4 py-3 w-full" data-id="element-132">Name</th>
                <th className="px-4 py-3 whitespace-nowrap" data-id="element-133">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200" data-id="element-134">
              {types.map(type => <tr key={type.id} className="hover:bg-slate-50" data-id="element-135">
                  <td className="px-4 py-3 font-medium" data-id="element-136">{type.name}</td>
                  <td className="px-4 py-3 whitespace-nowrap" data-id="element-137">
                    <div className="flex items-center gap-2" data-id="element-138">
                      <Button variant="ghost" size="icon" title="View" data-id="element-139">
                        <Eye className="h-4 w-4 text-slate-500" data-id="element-140" />
                      </Button>
                      <Link to={`/credit-types/edit/${type.id}`} data-id="element-141">
                        <Button variant="ghost" size="icon" title="Edit" data-id="element-142">
                          <Edit className="h-4 w-4 text-blue-600" data-id="element-143" />
                        </Button>
                      </Link>
                      <Button variant="ghost" size="icon" title="Delete" data-id="element-144">
                        <Trash2 className="h-4 w-4 text-red-600" data-id="element-145" />
                      </Button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>
    </div>;
}